import { useTranslation } from 'react-i18next';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import BoldLabel from '../components/BoldLabel';

const SECTIONS = ['austria', 'czechia', 'slovakia', 'hungary', 'slovenia'];

export default function BlogMultiCountryPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-bg">
        <div className="mx-auto max-w-3xl px-5 py-14">
          <span className="inline-flex rounded-full bg-primary-soft px-3 py-1 text-[12px] font-medium text-primary">{t('blog.post4.category')}</span>
          <h1 className="mt-3 text-[26px] font-bold tracking-tight">{t('blog.post4.title')}</h1>
          <p className="mt-2 text-[14px] text-muted">{t('blog.post4.readTime')}</p>
          <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-ink-soft">
            <p>{t('blog.post4.body.p1')}</p>

            {SECTIONS.map((c) => (
              <div key={c} className="space-y-2">
                <h3 className="text-[18px] font-semibold text-ink mt-6">{t(`blog.post4.body.section.${c}.heading`)}</h3>
                <p>{t(`blog.post4.body.section.${c}.body`)}</p>
              </div>
            ))}

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post4.body.tableHeading')}</h3>
            <div className="overflow-x-auto mt-2">
              <table className="w-full text-left text-[14px] border-collapse">
                <thead>
                  <tr className="border-b border-border">
                    <th className="py-2 pr-4 font-semibold">{t('blog.post7.body.table.head.country')}</th>
                    <th className="py-2 pr-4 font-semibold">{t('blog.post4.body.table.head.vignette')}</th>
                    <th className="py-2 pr-4 font-semibold">{t('blog.post4.body.table.head.trailer')}</th>
                    <th className="py-2 font-semibold">{t('blog.post4.body.table.head.bestPick')}</th>
                  </tr>
                </thead>
                <tbody>
                  {SECTIONS.map((c, i) => (
                    <tr key={c} className={i < SECTIONS.length - 1 ? 'border-b border-border' : ''}>
                      <td className="py-2 pr-4">{t(`blog.post7.body.table.${c}.name`)}</td>
                      <td className="py-2 pr-4">{t(`blog.post4.body.table.${c}.vignette`)}</td>
                      <td className="py-2 pr-4">{t(`blog.post4.body.table.${c}.trailer`)}</td>
                      <td className="py-2">{t(`blog.post4.body.table.${c}.bestPick`)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post4.body.itineraryHeading')}</h3>
            <p>{t('blog.post4.body.itinerary')}</p>
            <p><BoldLabel text={t('blog.post4.body.total')} /></p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
